'use strict';
import angular from 'angular';
import _ from 'lodash';

import adUnitsHtmlUrl from './views/ageTargetingList.html';

var app = angular.module('app.ageTargetingFbComponent', []);

app.component('ageTargetingFb', {
    bindings: {
        showActions: '=',
        selectedAgeTargeting: '='
    },
    templateUrl: adUnitsHtmlUrl,

    // The controller that handles our component logic
    controller: function (ProductService, $filter, $scope, FormService) {
        var self = this;
        self.ageList = [];
        self.ageRange = [];
        self.validateAge = function (type, model) {
            if (type == 'Age') {
                if (model.ageVal > model.ageRangeVal) {
                    if (model.ageVal == '65') {
                        model.ageRangeVal = model.ageVal + '+'
                    } else {
                        model.ageRangeVal = model.ageVal;
                    }
                }
            } else if (type == 'AgeRange') {
                if (model.ageRangeVal < model.ageVal) {
                    model.ageVal = model.ageRangeVal;
                }
            }
        }

        self.initComponent = function () {
            if (typeof self.selectedAgeTargeting == 'string') {
                self.selectedAgeTargeting = JSON.parse(self.selectedAgeTargeting);
            } else{
                self.selectedAgeTargeting ={};
                self.selectedAgeTargeting.ageVal = '13';
                self.selectedAgeTargeting.ageRangeVal = 65 + '+';
            }
            for (var i = 13; i <= 65; i++) {
                self.ageList.push(i.toString());
            }
            for (var i = 13; i <= 65; i++) {
                if (i == 65) {
                    self.ageRange.push(i + '+');
                } else {
                    self.ageRange.push(i.toString());
                }
            }
        };

        self.initComponent();
    }
});